import './VetRxDetailsBody.scss';

import { type JSX } from 'react';
import { type VetRxCats } from '@app/pdp/types';
import { type Document } from '@contentful/rich-text-types';
import { parseRichText, type Entry } from '@libs/contentful';
import { Heading, Image, TextPassage } from '@petsmart-ui/sparky';
import { type Asset } from 'contentful';
import { clsx, usePageLayout } from '@libs/common-next';

export default function VetRxDetailsBody({
    cat,
    vetRx,
}: {
    readonly cat: VetRxCats | null;
    readonly vetRx: readonly Entry<{ title: string }>[];
}): JSX.Element {
    const { flags } = usePageLayout();
    const relevant = vetRx
        .map(vetRxItem => vetRxItem.fields)
        .find(fields => fields?.title === cat);
    let entries = (relevant?.vetRxContentRepeater as Entry[]) ?? [];

    if (!flags.vetSourceRXEnabled) {
        entries = entries.filter(
            item =>
                item?.fields?.internalTitle !==
                'Provide pet & vet information (VetSource)'
        );
    } else {
        entries = entries.filter(
            item =>
                item?.fields?.internalTitle !==
                'Provide pet & vet information 2'
        );
    }

    return (
        <div className="vet-rx__rich-text">
            {relevant?.vetRxHeading ? (
                <Heading id="drawer-heading" tagName="h2">
                    {relevant.vetRxHeading as string}
                </Heading>
            ) : null}
            {entries.map((item, index) => (
                <div key={item.title as string}>
                    {item.fields?.image ? (
                        <Image
                            data-testid="vet-rx-image"
                            className={clsx(
                                'vet-rx__drawer-img',
                                index === 0 && 'vet-rx__drawer-img--first'
                            )}
                            src={
                                (item.fields?.image as Asset)?.fields?.file
                                    ?.url as string
                            }
                            alt={
                                (item.fields?.image as Asset)?.fields
                                    ?.title as string
                            }
                        />
                    ) : null}
                    <TextPassage className="vet-rx__subtitle" size="lg">
                        {item.fields?.subtitle as string}
                    </TextPassage>
                    <TextPassage>
                        {parseRichText(item.fields?.content as Document)}
                    </TextPassage>
                </div>
            ))}
        </div>
    );
}
